const { getFields, getTransformationQueryFields, getTransformationFieldSets, dataSourcesFieldSets } = require('./get-fields')
const walk = require('./walker')
const uniqBy = require('lodash/uniqBy')
const { matchPath } = require('react-router')

function resolveRef(id, path, app) {
  if(typeof id !== 'string') return id
  return app?.[path]?.[id]
}

function * pagesInUse (app, locations) {
  let pages = []
  const nav = app.nav || Object.values(app.navigation)[0]
  if(!locations) {
    pages = nav?.routes?.map(r => resolveRef(r.page, 'pages', app)) ?? []
  } else {
    for(let location of locations) {
      const rt = nav?.routes?.find(r => matchPath(location.redirectTo ?? location.pathname, { path: r.route, exact: true }))
      if(rt?.page) {
        pages.push(resolveRef(rt.page, 'pages', app))
      }
    }
  }
  const layout = resolveRef(app.layout || Object.values(app.layouts)[0], 'layouts', app)

  for (const p of [...pages, layout].filter(Boolean)) {
    yield p
  }
}
function getComponentFieldSets(app, comp, fieldSets = {}) {
  const mapping = resolveRef(comp.mapping, 'mapping', app)
  if(mapping) {
    dataSourcesFieldSets(mapping, fieldSets)
  }
  for(let c of comp.components ?? []) {
    getComponentFieldSets(app, c, fieldSets)
  }
  return fieldSets
}

function allFieldSetsInUse (app, locations) {
  const all = {}
  for (const p of pagesInUse(app, locations)) {
    const fs = getComponentFieldSets(app, p, {})
    for(let d in fs) {
      fs[d] = uniqBy(fs[d], 'fieldPath')
    }
    all[p.id] = fs
  }

  return all
}

function allDataSourcesInUse (_app) {
  const app = _app.$treenode ? _app.$treenode.snapshot : _app
  const all = new Set(Object.keys(app.dataSources))
  const a = new Set()

  for (const [node] of walk({ ...app, dataSources: null })) {
    if (typeof node === 'string') {
      const id = node.substring(node.lastIndexOf(':'))
      if (all.has(id)) a.add(node)
    }
  }

  function crawlDS(d, visited = new WeakSet()) {
    visited.add(d)
    for (const [node] of walk(d)) {
      if (typeof node === 'string') {
        const id = node.substring(node.lastIndexOf(':') + 1)
        if (all.has(id) && d.id !== id) {
          a.add(id)
          const ds = app.dataSources[id]
          if(!ds) console.log(id)
          if(!visited.has(ds)) crawlDS(ds, visited)
        }
      }
    }
  }

  for (const d of Object.values(app.dataSources)) {
    if (a.has(d.id)) crawlDS(d)
  }

  return Array.from(a)
}

function allComponentTypesInUse (app) {
  const all = new Set()
  for (const p of pagesInUse(app)) {
    for (const c of p.getAllComponents()) {
      all.add(c.type)
    }
  }
  return Array.from(all)
}

function getAllDataSources (m, all = new Set()) {
  if (m.children) {
    for (const c of m.children) getAllDataSources(c, all)
  }
  if (!m.bindingType) return all
  // so it works with snapshots too
  const id = m.dataSource && (typeof m.dataSource === 'string' ? m.dataSource : m.dataSource.id)

  if (m.dataSource) all.add(id)

  getDataSourcesFromReferences(m, all)

  if (m.dataTransformer) {
    for (const id in m.dataTransformer.dataSourceFieldSets) {
      all.add(id)
    }
  }
  if (m.type === 'Transformation' && m.value?.dataSourceFieldSets) {
    for (const id in m.value.dataSourceFieldSets) {
      all.add(id)
    }
  }
  return all
}

function getDataSourcesFromReferences (m, ds = new Set()) {
  if (m.value && m.value.referenceData) {
    const refData = Array.prototype.concat(m.value.referenceData).filter(r => r.dataSourceId)
    for (const rd of refData) {
      ds.add(rd.dataSourceId)
    }
  }
  return ds
}

function getMappingsForComponents(components, acc = [], p = []) {
  for(let c of components || []) {
    if (!c) continue;

    if(typeof c?.mapping === 'string') {
      acc.push(c.mapping)
    }
    getMappingsForComponents(c.components, acc, [...p, c.id])
  }

  return acc
}

module.exports = { getMappingsForComponents, getAllDataSources, dataSourcesFieldSets, allFieldSetsInUse, allDataSourcesInUse, allComponentTypesInUse }

if (typeof window !== 'undefined') window.deptree = module.exports
